<template>
    <button class="toggle" @click= "$emit('toggle-theme')"></button>
</template>

<script>
export default { name: "TheToggleButton" }
</script>

<style>

.toggle {
    --toggle-size: 30px;
    height: var(--toggle-size);
    width: var(--toggle-size);
    background-size: 80%;
    cursor: pointer;
    border: 1px dashed transparent;
    background-color: transparent;
    transition: box-shadow 300ms, background-color 300ms;

    background-position: center;
    background-repeat: no-repeat;
    border-radius: 50%;
}

.toggle:focus-visible {
    outline: transparent;
    border-color: var(--toggle-border-clr);
}

 #app[data-theme="dark"] .toggle {
    background-image: url(../../assets/icon-sun.svg);
}
 #app[data-theme="light"] .toggle {
     background-image: url(../../assets/icon-moon.svg);
}

#app[data-theme="dark"] .toggle:focus {
    --toggle-border-clr: rgb(219, 219, 219);
}

#app[data-theme="light"] .toggle:focus {
    --toggle-border-clr: white;
}

</style>